/* src/app/private/components/email-config/email-config/email-config.component.scss */
/*# sourceMappingURL=email-config.component.css.map */
